<template>
  <transition name="modal">

     <!-- New Modal -->
    <div class="modal-overlay" style="opacity: 1.09; display: block;">
      <div class="modal-wrapper showSweetAlert visible" data-custom-class="" data-has-cancel-button="true" data-has-confirm-button="true" data-allow-outside-click="false" data-has-done-function="true" data-animation="pop" data-timer="null" style="display: block; margin-top: -191px;">

        <em class="sa-icon sa-success icon-check"></em>
        <h2 class="modal-title">Great!</h2>
          <p class="modal-paragraph">
            {{ message }}
          </p>

        <div class="modal-buttons">
            <slot name="body">
              <div class="row">
                <div class="col-md-12 text-center">
                  <button class="btn btn-primary btn-lg btn-accept" @click="closeModal()">OK</button>
                </div>
              </div>
            </slot>
          </div>

      </div>
    </div>
  </transition>
</template>

<script>
  import {
    mapMutations,
    mapState,
  } from 'vuex';
  import {
    HIDE_SUCCESS_MODAL,
  } from '@/store/mutation-types';

  export default {
    name: 'success',
    props: ['closeAction'],
    computed: {
      ...mapState('success', [
        'message',
      ]),
    },
    methods: {
      ...mapMutations('success', {
        hideInformationModal: HIDE_SUCCESS_MODAL,
      }),
      closeModal() {
        this.hideInformationModal();
        if (typeof this.closeAction === 'function') {
          this.closeAction();
        }
      },
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .modal-wrapper p {
    font-size: 16px;
    text-align: center;
  }
  .modal-title {
    color: #27c24c;
    text-align: center;
  }
  .modal-paragraph {
    padding: 0 20px;
  }
  .modal-buttons {
    border-top: 1px solid #e5e5e5;
    position: relative;
    padding: 15px;
    margin-top: 40px;
  }
  .modal-buttons p {
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// Success.vue?613f335d